import PageLoading from "./PageLoading.vue";

export default PageLoading;
